export function formatLiteralValueCheck() {
  return "expected value to match literal value";
}
